import { render, staticRenderFns } from "./SlaPolicyForm.vue?vue&type=template&id=0dff211b&scoped=true"
import script from "./SlaPolicyForm.vue?vue&type=script&lang=js"
export * from "./SlaPolicyForm.vue?vue&type=script&lang=js"
import style0 from "./SlaPolicyForm.vue?vue&type=style&index=0&id=0dff211b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dff211b",
  null
  
)

export default component.exports